import getBody from './getBody';
import { Position } from '../enums/Enum';
import getViewport from './getViewport';

// determines the "top" coordinate needed to create a fixed position simulation
/* If this context will be provided than this function will return the scroll position of that specific context */
const getFixedTop = (position, container, padding, forceEdge, context) => {
    let scroll;
    if (context) {
        scroll = context.documentElement.scrollTop
            ? context.documentElement.scrollTop
            : getBody(context).scrollTop;
    } else {
        scroll = document.documentElement.scrollTop
            ? document.documentElement.scrollTop
            : getBody().scrollTop;
    }
    if (!container) {
        // If container is NULL then just assign it.
        container = document.getElementById('apexchat');
    }
    if (container.offsetHeight) {
        const dims = getViewport();
        const halfHeight = dims[1] / 2 - container.offsetHeight / 2;

        const pos = position == Position.Center
            ? halfHeight + scroll
            : dims[1] - container.offsetHeight + scroll;
        return `${pos - (padding || 0)}px`;
    }
};
export default getFixedTop;
